import { useQuery } from '@tanstack/react-query';
import { useAuth0 } from '@auth0/auth0-react';
import { getCategories } from '../services/masterProductsApi';

export default function useCategories() {
  const { getAccessTokenSilently } = useAuth0();

  const { data, isLoading, error } = useQuery({
    queryKey: ['masterProductCategories'],
    queryFn: async () => {
      const token = await getAccessTokenSilently();
      return getCategories(token);
    },
    staleTime: 30 * 60 * 1000, // 30 minutes - categories don't change often
    gcTime: 60 * 60 * 1000 // 1 hour
  });

  // Build category tree
  const buildCategoryTree = (categories) => {
    if (!categories) return [];

    const categoryMap = {};
    const rootCategories = [];

    // Create map
    categories.forEach(cat => {
      categoryMap[cat.id] = { ...cat, children: [] };
    });

    // Build tree
    categories.forEach(cat => {
      if (cat.parent_category_id) {
        const parent = categoryMap[cat.parent_category_id];
        if (parent) {
          parent.children.push(categoryMap[cat.id]);
        }
      } else {
        rootCategories.push(categoryMap[cat.id]);
      }
    });

    return rootCategories;
  };

  return {
    categories: data || [],
    categoryTree: buildCategoryTree(data),
    isLoading,
    error
  };
}
